<template>
  <div class="container" :style="{display: noAccess ? 'flex' : 'none'}">
    <div v-if="noAccess" class="warning-container">
      <p class="warning">
        Your VRpatients account is not active.<br>
        In order to access VRpatients content, your account must be associated with an organization.
      </p>
      <md-button class="md-raised md-accent" @click="logout">
        Logout
      </md-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'no-org-guard',
  props: {
    user: {
      type: Object,
      default: () => {}
    },
  },
  computed: {
    noAccess() {
      if (!this.user) {
        return false;
      }
      return !this.user.groups || !this.user.groups.length;
    },
  },
  mounted() {
    if (this.noAccess) {
      window.location.replace('/auth/account/profile');
    }
  },
  methods: {
    logout() {
      this.$emit('logout');
    },
  }
};
</script>

<style scoped>
.container {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #525252;
}

.warning-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.warning {
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  line-height: normal;
}
</style>